
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@environments/environment';


export interface AuthResponse {
    access_token: string;
    token_type: string;
    refresh_token: string;
    'user-email': string;
    'user-id': -2;
}

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private readonly baseUrl = environment.http.apiRoot;
    private readonly basicAuthData = window.btoa(environment.http.basicAuth.username + ':' + environment.http.basicAuth.password);
    private authSubject: BehaviorSubject<AuthResponse>;
    public auth: Observable<AuthResponse>;

    constructor(private http: HttpClient) {
        this.authSubject = new BehaviorSubject<AuthResponse>(JSON.parse(localStorage.getItem('auth')));
        this.auth = this.authSubject.asObservable();
    }

    public get authValue(): AuthResponse {
        return this.authSubject.value;
    }

    login(username: string, password: string) {

        const body = new HttpParams()
            .set('grant_type', 'password')
            .set('username', username)
            .set('password', password);

        return this.http.post<any>(`${this.baseUrl}/oauth/token`,
            body.toString(),
            {
                headers: new HttpHeaders()
                    .set('Content-Type', 'application/x-www-form-urlencoded')
                    .set('Authorization', `Basic ${this.basicAuthData}`)
            }).pipe(
                map(res => {
                    localStorage.setItem('auth', JSON.stringify(res));
                    this.authSubject.next(res);
                    return res;
                }));
    }

    logout() {
        localStorage.removeItem('first');
        localStorage.removeItem('patient');
        localStorage.removeItem('auth');
        localStorage.removeItem('patientSearchForm');
        this.authSubject.next(null);
    }
}
